
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { API_ENDPOINTS } from '../data/client/api-endpoints';
import { 
  getForumDetails, 
  getUserScreens, 
  getUserFollowScreens, 
  deleteScreen,
  getUserDashboardStats 
} from './client/dashboard-client';
import { mapPaginatorData } from '../utils/data-mappers';


export const useForumQuery = ( params ) => {
  //console.log("params====", params);
  const { data, error, isLoading } = useQuery({
    queryKey: ["user-forums", params],
    queryFn: () => getForumDetails.get( { ...params } ),
    keepPreviousData: true,
  });
  console.log("forum details data:", params, data);
  return {
    forums: data?.data,    
    paginatorInfo: mapPaginatorData(data),
    error,
    isLoading,
  };
};

export const useUserScreensQuery = ( params ) => {
  //console.log("params====", params);
  const { data, error, isLoading } = useQuery({
    queryKey: ["user-screens", params],
    queryFn: () => getUserScreens.get( { ...params } ),
    keepPreviousData: true,
  });
  //console.log("forum details data:", params, data);
  return {
    screens: data?.data,    
    paginatorInfo: mapPaginatorData(data),
    error,
    isLoading,
  };
};

export const useUserFollowScreensQuery = ( params ) => {
  //console.log("params====", params);
  const { data, error, isLoading } = useQuery({
    queryKey: ['user-follow-screens', params],
    queryFn: () => getUserFollowScreens.get( { ...params } ),
    keepPreviousData: true,
  });
  //console.log("forum details data:", params, data);
  return {
    screens: data?.data,    
    paginatorInfo: mapPaginatorData(data),
    error,
    isLoading,
  };
};

export const useIndicesQuery = ( params ) => {
  //console.log("params====", params);
  const { data, error, isLoading } = useQuery({
    queryKey: [API_ENDPOINTS.INDICES, params],
    queryFn: () => getForumDetails.all( params ),
    keepPreviousData: true,
  });
  console.log("Indices list data:", params, data);
  return {
    sectors: data?.data,    
    paginatorInfo: mapPaginatorData(data),
    error,
    isLoading,
  };
};

export const useDeleteScreenMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (screenId) => deleteScreen(screenId),

    onSuccess: () => {
      // 🔥 Reload user screens after deletion
      queryClient.invalidateQueries({
        queryKey: ["user-screens"]
      });
    }
  });
}

export const useUserDashboardStatsQuery = ( params ) => {
  //console.log("params====", params);
  const { data, error, isLoading } = useQuery({
    queryKey: ['user-dashboard-stats', params],
    queryFn: () => getUserDashboardStats.get( { ...params } ),
    keepPreviousData: true,
  });
  //console.log("user dashboard stats data:", params, data);
  return {
    stats: data?.data,        
    error,
    isLoading,
  };
};